const React = require('react');
const filter = require('mn-utils/filter');

const {backLocation} = require('../../../../router');
const {apiV2GetTransactionDetails} = require('../../../../api/merchant/transactions');
const checkingForUpdatesProvider = require('../../../../utils/checkingForUpdatesProvider');
const toEllipsisMiddle = require('../../../../utils/toEllipsisMiddle');

const {apiV2SendTransactionCallback} = require("../../../../api/merchant/transactions");
const {openPopupInfo} = require("../../../../emitters/popup");


const WrapperWithLoading = require('../../../dumb/WrapperWithLoading/B');
const Caption = require('../../../dumb/Caption/C');
const withState = require('../../../../utils/withState');
const ButtonBack = require('../../../dumb/Button/BackB');
const Button = require('../../../dumb/Button/M');

const PrimaryDataDisplay = require('./PrimaryDataDisplay');
const SecondaryDataDisplay = require('./SecondaryDataDisplay');

module.exports = withState((setState) => {
  const checkingForUpdates = checkingForUpdatesProvider(setState, (params) => {
    return apiV2GetTransactionDetails(filter({
      id: params.trxId
    }));
  });

  return (state, props) => {
    const params = props.params || {};

    checkingForUpdates(params);

    const data = state.data || {};

    return (
      <WrapperWithLoading
        className={'wmin270 wmax1000 ' + (props.className || '')}
        loading={state.loading}
      >
        <div className="layoutRow jcSB aiC fxwWrap dB@m">
          <div className="layoutRow aiC fxwWrap">
            <ButtonBack
              className="m-10 mr24"
              onClick={backLocation}
            />
            <Caption className="fxUnset@m mr24 mv10@m">
              Transaction details
            </Caption>
            <div className="f23 fw3 lh34 mv10@m">
              {toEllipsisMiddle(data.id, 15)}
            </div>
          </div>
          {/*<div className="layoutRow aiC mt20@m">*/}
          {/*  <div className="ml36 ml0@m">*/}
          {/*    <ButtonPrintA*/}
          {/*      onClick={() => console.log('Start printing')}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*  <div className="ml36">*/}
          {/*    <DownloadA*/}
          {/*      onClick={() => console.log('Start download')}*/}
          {/*    />*/}
          {/*  </div>*/}
          {/*</div>*/}
        </div>
        <PrimaryDataDisplay data={data} />
        <div className="h1 bgDADCE1 mt45 mb45"/>
        <SecondaryDataDisplay data={data}/>
        {data.state === 'completed' && (
          <div className="w268 mt34 mr64">
            <Button onClick={() => {
              apiV2SendTransactionCallback(data.id).then(() => openPopupInfo(['We\'ve sent you a callback']))
            }}>
              Send callback
            </Button>
          </div>
        )}
      </WrapperWithLoading>
    );
  };
});
